import { useQuery } from "@tanstack/react-query";
import { REGISTRATION_TYPES_KEY } from "../constants";
import { httpClient } from "../../config";
import { API_REGISTRATION_TYPES } from "../../common/consts/apiUrls";

export interface RegistrationTypesResponse {
  message: string;
  data: {
    registration_types: RegistrationType[];
  };
}

export interface RegistrationType {
  id: number;
  registration_type: string;
  active: boolean;
}

const fetchRegistrationTypes = async (): Promise<RegistrationTypesResponse> => {
  return (await httpClient.get(API_REGISTRATION_TYPES)) as RegistrationTypesResponse;
};

export default function useRegistrationTypesQuery(enabled = true) {
  return useQuery({
    queryKey: [REGISTRATION_TYPES_KEY],
    queryFn: fetchRegistrationTypes,
    enabled,
  });
}
